module.exports = __webpack_public_path__ + "static/img/90011B_2_3_R_20200527_LC.1ba6798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/90011B_2_3_R_20200527_LC.png
// module id = ZE/H
// module chunks = 0